// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ":root {\n  --grey: #efefef;\n\n  --border-c: var(--black-10);\n\n  --page-pad: 16px;\n\n  --page-mw: 1440px;\n  --page-w: min(var(--page-mw), 100vw);\n\n  --side-wide-w: 220px;\n  --side-mini-w: 64px;\n  --side-w: var(--side-wide-w);\n\n  --zi-dropdown: 110;\n\n  --created: rgb(242, 255, 245);\n  --updated: rgba(255, 252, 240, 0.85);\n}\n", ""]);
// Exports
module.exports = exports;
